type HistoireImageProps = {
  img: string;
  legende?: string;
  credit?: string;
};

const images: HistoireImageProps[] = [
  { img: "/photos/LeClub/6FrenchLeague(2021)(1).webp", legende: "6 French League (2021)", credit: "Timo Verdeil" },
  { img: "/photos/LeClub/6FrenchLeague(2021)(2).webp", legende: "6 French League (2021)", credit: "Timo Verdeil" },
  { img: "/photos/LeClub/6FrenchLeague(2021)(3).webp", legende: "6 French League (2021)", credit: "Timo Verdeil" },
  { img: "/photos/LeClub/6FrenchLeague(2021)(4).webp", legende: "6 French League (2021)", credit: "Timo Verdeil" },
  { img: "/photos/LeClub/CoupeDeFrance(2017)(1).webp", legende: "Coupe de France (2017)", credit: "R3SIAK" },
  { img: "/photos/LeClub/CoupeDeFrance(2017)(2).webp", legende: "Coupe de France (2017)", credit: "R3SIAK" },
  { img: "/photos/LeClub/CoupeDeFrance(2017)(3).webp", legende: "Coupe de France (2017)", credit: "R3SIAK" },
  { img: "/photos/LeClub/CoupeDeFrance(2018)(1).webp", legende: "Coupe de France (2018)", credit: "ESIX" },
  { img: "/photos/LeClub/CoupeDeFrance(2018)(2).webp", legende: "Coupe de France (2018)", credit: "ESIX" },
  { img: "/photos/LeClub/CoupeDeFrance(2018)(3).webp", legende: "Coupe de France (2018)", credit: "ESIX" },
  { img: "/photos/LeClub/CoupeDeFrance(2018)(4).webp", legende: "Coupe de France (2018)", credit: "ESIX" },
  { img: "/photos/LeClub/CoupeDeFrance(2018)(5).webp", legende: "Coupe de France (2018)", credit: "ESIX" },
  { img: "/photos/LeClub/GamersAssembly(2019)(1).webp", legende: "Gamers Assembly (2019)", credit: "ESIX" },
  { img: "/photos/LeClub/GamersAssembly(2019)(2).webp", legende: "Gamers Assembly (2019)", credit: "ESIX" },
  { img: "/photos/LeClub/OpenCup(2021)(1).webp", legende: "Open Cup (2021)", credit: "WoL" },
];

export default images;
